import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppRoutes } from 'modules/router';
import { selectLocationState } from 'modules/router/state';
import { goBack, push } from 'redux-first-history';

import type { CallHistoryMethodAction } from 'redux-first-history/build/es6/actions';
import type { RootState } from 'store';
import type { ReportSource } from 'store/apis/insightsReport';

export const exitWizardAction = createAsyncThunk<CallHistoryMethodAction, { shouldGoBack?: boolean } | undefined>(
  '[Insights Reports Wizard NavigationBar] exit button clicked',
  ({ shouldGoBack = true } = {}, { dispatch, getState }) => {
    const state = getState() as RootState;
    const locationState = selectLocationState(state);

    if (locationState && shouldGoBack) {
      return dispatch(goBack());
    }

    return dispatch(push(AppRoutes.InsightsReports + AppRoutes.InsightsReportsEvents));
  }
);

export const insightsReportsWizardActions = {
  exit: exitWizardAction,
  reportSources: {
    reportSourceSelected: createAction<ReportSource | undefined>(
      '[Insights Reports Wizard ReportSourcesTable] report source selected'
    ),
    setInitialReportSource: createAction<Pick<ReportSource, 'id' | 'name'> | undefined>(
      '[Insights Reports Wizard ReportSourcesTable] initial report source set'
    ),
  },
  similarReportSources: {
    selectAllCheckboxToggled: createAction<{ isChecked: boolean }>(
      '[Insights Reports Wizard SimilarReportSourcesTable] select all checkbox toggled'
    ),
    reportSourceSelected: createAction<ReportSource>(
      '[Insights Reports Wizard ReportSourcesTable] similar report sources selected'
    ),
    similarReportSourcesFetched: createAction<ReportSource[]>(
      '[Insights Reports Wizard ReportSourcesTable] similar report sources fetched'
    ),
    similarReportSourcesClosed: createAction(
      '[Insights Reports Wizard ReportSourcesTable] similar report sources closed'
    ),
  },
};
